export default "__VITE_ASSET__f115c144__"